import React, { useState } from 'react';
import apiClient from '../lib/apiClient';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        setMessage('');
        setError('');
        try {
            const response = await apiClient.post('/api/forgot-password', { email });
            setMessage(response.data?.message || 'If an account exists for that email, a reset link has been sent.');
        } catch (err) {
            setError(err.response?.data?.error || 'Unable to send reset link right now.');
        } finally {
            setLoading(false);
        }
    };

    const styles = {
        container: {
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(135deg, #3457D5 0%, #7CD845 100%)',
            padding: '20px',
        },
        card: {
            background: '#FFFFFF',
            borderRadius: '24px',
            padding: '48px',
            maxWidth: '460px',
            width: '100%',
            boxShadow: '0 20px 60px rgba(0,0,0,0.25)',
        },
        logo: { display: 'block', width: '64px', height: '64px', objectFit: 'contain', margin: '0 auto 12px' },
        title: { fontSize: '28px', fontWeight: '700', color: '#2B2B2B', marginBottom: '8px', textAlign: 'center' },
        subtitle: { fontSize: '15px', color: '#6E6E6E', marginBottom: '28px', textAlign: 'center', lineHeight: 1.6 },
        input: { width: '100%', padding: '12px 16px', fontSize: '15px', border: '1px solid #E5E5E5', borderRadius: '12px', marginBottom: '16px', outline: 'none' },
        button: { width: '100%', padding: '16px', background: '#3457D5', color: '#FFFFFF', border: 'none', borderRadius: '12px', fontSize: '16px', fontWeight: '600', cursor: 'pointer' },
        info: { padding: '12px 16px', borderRadius: '12px', marginBottom: '20px', fontSize: '14px', lineHeight: 1.5 },
        error: { background: '#FFE0E0', color: '#D81F26' },
        success: { background: '#E7F7EC', color: '#1E7A3E' },
        footer: { marginTop: '24px', textAlign: 'center', fontSize: '14px', color: '#6E6E6E' },
        link: { color: '#3457D5', textDecoration: 'none', fontWeight: '600' },
    };

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <img src="/corpusio-logo.webp" alt="Corpusio" style={styles.logo} />
                <h1 style={styles.title}>Reset your password</h1>
                <p style={styles.subtitle}>
                    Enter your account email and we&apos;ll send you a secure link to choose a new password.
                </p>
                {error && <div style={{ ...styles.info, ...styles.error }}>{error}</div>}
                {message && <div style={{ ...styles.info, ...styles.success }}>{message}</div>}
                <form onSubmit={handleSubmit}>
                    <input
                        type="email"
                        placeholder="Email address"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        style={styles.input}
                    />
                    <button type="submit" style={styles.button} disabled={loading}>
                        {loading ? 'Sending reset link...' : 'Send reset link'}
                    </button>
                </form>
                <div style={styles.footer}>
                    Remembered it? <a href="/login" style={styles.link}>Back to sign in</a>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
